let config = {
  clientUrl: "https://yuvashiksha.netlify.app",
  serverUrl: "https://yuvashiksha.herokuapp.com",
};

export default config;
